"use client";

import { useLocale, useTranslations } from "next-intl";
import { useRouter } from "next/navigation";
import { LOCALE_COOKIE, LOCALE_FLAG_EMOJI, LOCALES, type AppLocale } from "@/lib/i18n-config";

export default function LocaleSwitcher() {
  const t = useTranslations("LocaleSwitcher");
  const locale = useLocale() as AppLocale;
  const router = useRouter();

  function setLocale(next: AppLocale) {
    if (next === locale) return;
    document.cookie = `${LOCALE_COOKIE}=${next};path=/;max-age=31536000;SameSite=Lax`;
    router.refresh();
  }

  return (
    <div
      className="inline-flex rounded-md border border-gray-200/90 p-0.5 dark:border-gray-700/90"
      role="group"
      aria-label={t("label")}
    >
      {LOCALES.map((loc) => (
        <button
          key={loc}
          type="button"
          onClick={() => setLocale(loc)}
          aria-label={t(loc)}
          title={t(loc)}
          aria-pressed={locale === loc}
          className={`inline-flex h-8 w-8 items-center justify-center rounded text-[17px] leading-none transition-colors select-none ${
            locale === loc
              ? "bg-gray-100 shadow-sm dark:bg-gray-800"
              : "text-gray-500 opacity-65 hover:bg-gray-50 hover:opacity-100 dark:text-gray-400 dark:hover:bg-gray-800/80"
          }`}
        >
          <span aria-hidden>{LOCALE_FLAG_EMOJI[loc]}</span>
        </button>
      ))}
    </div>
  );
}
